import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];
const VIEWPORT = { once: true, margin: "-80px" };
const REVEALED = { opacity: 1, y: 0 };

export const Reveal = ({ children, delay = 0, y = 36, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={REVEALED}
    viewport={VIEWPORT}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ number, label }) => (
  <p className="font-manrope text-xs font-bold uppercase tracking-[0.3em] text-fresh">
    {number} / {label}
  </p>
);
